function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wzgbapom0a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4466",
    style: {
      fill: "#032541"
    },
    d: "M0 0h70v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "jj6srd7pdb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 28492",
    transform: "translate(.167 .166)",
    style: {
      fill: "#032541"
    },
    d: "M0 0h58v58H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "icn/evoucher",
    style: {
      clipPath: "url(#wzgbapom0a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 79259"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 79258",
    transform: "translate(5.833 5.833)",
    style: {
      clipPath: "url(#jj6srd7pdb)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 66165",
    d: "M95.909 0h-.319a4.958 4.958 0 0 0-4.764 3.76 4.909 4.909 0 0 1-9.47 0A4.958 4.958 0 0 0 76.592 0h-.319A12.287 12.287 0 0 0 64 12.273v39.272a7.364 7.364 0 0 0 7.364 7.364h5.228a4.958 4.958 0 0 0 4.764-3.76 4.909 4.909 0 0 1 9.47 0 4.958 4.958 0 0 0 4.764 3.76h5.228a7.364 7.364 0 0 0 7.364-7.364V12.273A12.287 12.287 0 0 0 95.909 0m4.909 54-5.26-.155A9.818 9.818 0 0 0 76.592 54h-5.228a2.454 2.454 0 0 1-2.454-2.455v-9.818h4.909a2.455 2.455 0 1 0 0-4.909h-4.91V12.273a7.364 7.364 0 0 1 7.364-7.364l.351.155a9.843 9.843 0 0 0 9.467 7.209 9.993 9.993 0 0 0 9.556-7.364h.263a7.364 7.364 0 0 1 7.364 7.364v24.545h-4.91a2.455 2.455 0 1 0 0 4.909h4.909v9.818A2.454 2.454 0 0 1 100.818 54",
    transform: "translate(-56.965 -.247)",
    style: {
      fill: "#032541"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 66166",
    d: "M220.7 320h-4.909a2.455 2.455 0 0 0 0 4.909h4.909a2.455 2.455 0 1 0 0-4.909",
    transform: "translate(-189.116 -283.429)",
    style: {
      fill: "#032541"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvoc);
export default __webpack_public_path__ + "static/media/evoc.a4e0474b807cb8f356b11d424604ddb3.svg";
export { ForwardRef as ReactComponent };